export const baseURLEndpoint = process.env.REACT_APP_BASE_URL_ENDPOINT
export const uploaderEndpoint = process.env.REACT_APP_UPLOADER_ENDPOINT
export const socketHost = process.env.REACT_APP_SOCKET_HOST
export const tokenCustomer = process.env.REACT_APP_TOKEN_CUSTOMER
export const tokenUser = process.env.REACT_APP_TOKEN_USER
// export const baseURLEndpoint = "http://localhost:3001/api/v1"
// export const customerClientID = "customer";
// export const customerSecret = "7a*d|*`)XniR/I<^J>+Z!|ST<}}p,nU`JX@Pl5P%u@c,nLlXeRT][dlb{S.*^>&3";
// export const customerEndpointPrefix = "/api/v1/c";

// export const designdeskClientID = "designdesk";
// export const designdeskSecret = "=XQ&N=3~uJk9wC6U3v8v;~=+}2xeaXkxbZFar#pJl;HCoha}dt1t7[|SZ,/_UFdn";
// export const designdeskEndpointPrefix = "/api/v1/d";

export const production = process.env.NODE_ENV === 'production'
export const defaultAvatar = process.env.REACT_APP_DEFAULT_AVATAR
export const privacyPolicyLink = process.env.REACT_APP_PRIVACY_POLICY
export const termAndConditionsLink = process.env.REACT_APP_TERM_CONDITION
export const sentryDNS = process.env.REACT_APP_SENTRY_DNS
// export const tidioCode = process.env.REACT_APP_TIDIO_CODE
export const siteName = process.env.REACT_APP_SITE_NAME

export const maxCreditCardLength = 16

// NGS-1780: order search runs an unindexed collection scan on the API, so a
// broad term can take minutes. Bound the wait on the endpoints that carry
// customSearch instead of leaving the XHR open indefinitely (axios default 0).
// Generous on purpose - this is for UI honesty, not for shedding server load;
// aborting the XHR does not stop work already running on the API.
export const searchRequestTimeout = 60000

// NGS-1780: the API builds seven unanchored case-insensitive regexes from
// customSearch, which no index can serve - a one-character term scans every
// card. Terms shorter than this never go out on the wire.
export const MIN_SEARCH_LENGTH = 3

export const isSearchable = (term) =>
  typeof term === 'string' && term.trim().length >= MIN_SEARCH_LENGTH
